export default "__VITE_ASSET__$PcxuNYV__"